let CONSTANT = {};
// CONSTANT.API_BASE_URL = 'http://localhost:5000/';
CONSTANT.API_BASE_URL = 'https://apiserver.sentinix.in/';
export default CONSTANT;
